import React from 'react';
import PropTypes from 'prop-types';
import { isNull } from 'lodash';
import { pluralize } from 'humanize-plus';
import {
  BILLING_INTERVAL_EIGHT_MIN_RULE,
  MINIMUM_PAID_DURATION_EIGHT_MIN_RULE,
  CMS_EIGHT_MIN_RULE,
} from 'src/pages/invoices/constants';
import { getBillableUnits } from './utils';

const PaymentsTimeBasedBillableUnits = ({
  authorizedUnits,
  unitAmountCalculationHint,
  serviceDuration,
  remainingAuthorizedAmount,
}) => {
  const units = !isNull(authorizedUnits) ? authorizedUnits : getBillableUnits(
    unitAmountCalculationHint,
    serviceDuration,
    remainingAuthorizedAmount,
  );

  let result = '--';
  if (!isNull(units) && unitAmountCalculationHint === CMS_EIGHT_MIN_RULE) {
    const minRange = units === 0 ? 0 :
      ((units - 1) * BILLING_INTERVAL_EIGHT_MIN_RULE) + MINIMUM_PAID_DURATION_EIGHT_MIN_RULE;
    const maxRange = units === 0 ? MINIMUM_PAID_DURATION_EIGHT_MIN_RULE - 1 :
      minRange + BILLING_INTERVAL_EIGHT_MIN_RULE - 1;
    result = `${units} ${pluralize(units, 'unit')} (${minRange}-${maxRange} minutes)`;
  }
  return (
    <span>{result}</span>
  );
};

PaymentsTimeBasedBillableUnits.propTypes = {
  authorizedUnits: PropTypes.number,
  unitAmountCalculationHint: PropTypes.string.isRequired,
  serviceDuration: PropTypes.number,
  remainingAuthorizedAmount: PropTypes.number,
};

PaymentsTimeBasedBillableUnits.defaultProps = {
  authorizedUnits: null,
  serviceDuration: null,
  remainingAuthorizedAmount: null,
};

export default PaymentsTimeBasedBillableUnits;
